import { drawing, geometry } from '@progress/kendo-drawing';
import { START } from '../constants.js';
import { MarkerBase } from './MarkerBase.js';
import { deepExtend } from '../utils/deep-extend.js';

const defaultOptions = {
    radius: 4,
    anchor: {
        x: 0,
        y: 0
    }
};
class CircleMarker extends MarkerBase {
    constructor(options) {
        options = deepExtend({}, defaultOptions, options);
        super(options);
    }
    createElement() {
        const options = this.options;
        this.drawingElement = new drawing.Circle(new geometry.Circle(this.anchor, options.radius), {
            fill: options.fill,
            stroke: options.stroke
        });
    }
    positionMarker(path) {
        const options = this.options;
        const position = options.position;
        const segments = path.segments;
        let targetSegment;
        let point;
        if (position === START) {
            targetSegment = segments[0];
        }
        else {
            targetSegment = segments[segments.length - 1];
        }
        if (targetSegment) {
            point = this._transformToPath(targetSegment.anchor(), path);
            this.drawingElement.transform(geometry.transform().translate(point.x, point.y));
        }
    }
}

export { CircleMarker };
